import { useEffect } from 'react';

import _startCase from 'lodash.startcase';

import { useSoftphoneModalContext } from 'lib/common/contexts/SoftphoneModalContext';
import { useLayout } from 'lib/common/contexts/layout/LayoutContext';

import Modal from 'lib/common/components/Modal';
import Text from 'lib/common/components/Text';

interface IEndTaskWarningModal {
  open: boolean;
  onClose: () => void;
  onSave: () => void;
  bodyText?: string;
  taskType?: string;
}

const EndTaskWarningModal = ({ open, onClose, onSave, bodyText, taskType }: IEndTaskWarningModal) => {
  const { isSoftphone } = useLayout();
  const {
    state: { isModalOpen },
    actions: { openModal, closeModal },
  } = useSoftphoneModalContext();

  useEffect(() => {
    if (!isSoftphone || !open) {
      return;
    }

    if (!isModalOpen) {
      openModal({
        title: 'Warning',
        content: <Text preLine>{bodyText?.replace(/\\n/g, `\n`)}</Text>,
        onDelete: onSave,
        invertButtonOrder: true,
        secondaryButtonText: 'Continue',
        deleteButtonText: `End ${taskType ? _startCase(taskType.toLowerCase()) : ''}`,
        onClose,
        onSuccess: () => {
          onClose();
          closeModal();
        },
      });
    }
  }, [isSoftphone, open]);

  // Close the modal if we're on softphone (desktop will just be unmounted) when this is unmounted
  useEffect(() => {
    if (isSoftphone && open) {
      closeModal();
    }
  }, []);

  // Modals on Softphone are rendered by function calls and nothing needs to be rendered here
  if (isSoftphone) {
    return null;
  }

  return (
    <Modal
      open={open}
      onClose={onClose}
      onSuccess={onClose}
      onDelete={onSave}
      title="Warning"
      deleteButtonText={`End ${taskType ? _startCase(taskType.toLowerCase()) : ''}`}
      secondaryButtonText="Continue"
      invertButtonOrder
    >
      <Text preLine>{bodyText?.replace(/\\n/g, `\n`)}</Text>
    </Modal>
  );
};

export default EndTaskWarningModal;
